import React, { PureComponent } from 'react';
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, AreaChart, Area } from 'recharts';
import { timeFormat } from 'd3-time-format';
import _t from 'counterpart';
import { IWalletPerformanceRecord } from './types';
import { formatCurrency } from '../../helpers';

interface ChartProps {
  data: Array<IWalletPerformanceRecord>;
}

export default class PerformanceChart extends PureComponent<ChartProps> {
  tickFormatter(tick: string) {
    return timeFormat('%m/%d')(new Date(tick));
  }

  renderTime(timePoint: string): string {
    return this.tickFormatter(timePoint.toLocaleString());
  }

  render() {
    const CustomTooltip = ({ active, payload, label }: any) => {
      if (!active || !payload || !payload.length) return null;

      const data = payload[0].payload;

      return (
        <div
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '10px',
          }}
        >
          <p style={{ margin: '0 0 5px 0', fontWeight: 'bold' }}>{this.renderTime(label.toString())}</p>
          <p style={{ margin: '3px 0', color: 'var(--primary)' }}>
            <strong>{_t('wallet.equity')}:</strong> {formatCurrency(data.equity)}
          </p>
          <p style={{ margin: '3px 0', color: 'var(--success)' }}>
            <strong>{_t('wallet.balance-performance')}:</strong> {formatCurrency(data.balance)}
          </p>
          <p style={{ margin: '3px 0', color: 'var(--warning)' }}>
            <strong>{_t('wallet.credit-performance')}:</strong> {formatCurrency(data.credit)}
          </p>
        </div>
      );
    };

    const { data } = this.props;

    return (
      <ResponsiveContainer width="100%" height={400}>
        <AreaChart
          data={data}
          margin={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        >
          <defs>
            <linearGradient id="equityArea" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="var(--primary)" stopOpacity={0.8} />
              <stop offset="95%" stopColor="var(--primary)" stopOpacity={0} />
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" interval="preserveStartEnd" tickFormatter={this.tickFormatter} />
          <YAxis domain={[0, (dataMax: number) => dataMax * 1.1]} tickFormatter={(v) => formatCurrency(v, 'USD', 0)} />

          <Tooltip content={<CustomTooltip />} />
          <Legend iconType="plainline" />
          <Area
            type="monotone"
            dataKey="equity"
            fill="url(#equityArea)"
            stroke="var(--primary)"
            strokeWidth="2"
            dot={false}
            activeDot={{ r: 4 }}
            name={_t('wallet.equity')}
          />
        </AreaChart>
      </ResponsiveContainer>
    );
  }
}
